/**
 * Public exports for Paper2Ink Web API module.
 */

export * from "./types.ts";
export * from "./client.ts";
export * from "./authLibrary.ts";

import { Paper2InkApiClient } from "./client.ts";

export function createApiClient(baseUrl?: string): Paper2InkApiClient {
  return new Paper2InkApiClient({ baseUrl });
}
